import React from 'react';
import Utils from '../../utils/Validate'
import { CONSTANTES } from '../../utils/Constantes';
import iconSelect from '../../resource/svg/iconSelect.svg';

const Select = ({lista, onChange, name, validate, placeholder, value, titulo, detalle="detalle", llave, clase = undefined, disabledSelect, habilitarValorInicial }) => {
    // console.log(lista);
    return (<div className={(clase || '')+" input-field"}>
        { (/*validate === true &&*/ (value && value !=='||')) ? <p className="placeholderSelect">{ titulo }</p> : null }
        <select  disabled={disabledSelect} id={name} name={name} className={"browser-default" + (validate === false ? ' input-error' : '')}  value={ value } onChange = { onChange } style={(value=='||' || !value)?{color:'#A9B1D1'}:{}}>
           { clase ? null : <option value={CONSTANTES.SEPARADOR} /*disabled={habilitarValorInicial ? "" : "disabled" }*/ style={{display: (habilitarValorInicial)?'block':'none', color:'#A9B1D1'}}>{ titulo }</option> }
            
        	{ lista.map((item, i) => <option key={i} value={ item["value"] + CONSTANTES.SEPARADOR + item[detalle] } style={{color:'#494F66'}}>{ item[detalle] }</option> ) }
        
        </select>
        <img  className={disabledSelect ? "iconSelect-disabled" : "iconSelect"} src={iconSelect} alt=""/>
        {(validate === false) ? <span className="message-error">* Ingrese un {Utils.convertirMinusculas(placeholder)} válido</span> : null} 
    </div>)}

export default Select;